import { render, staticRenderFns } from "./FrzCustomCardParihuelaCalifornian.vue?vue&type=template&id=3966085a"
import script from "./FrzCustomCardParihuelaCalifornian.vue?vue&type=script&lang=js"
export * from "./FrzCustomCardParihuelaCalifornian.vue?vue&type=script&lang=js"
import style0 from "./FrzCustomCardParihuelaCalifornian.vue?vue&type=style&index=0&id=3966085a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports